export const en = {
  globals: {
    save: "save",
    submit: "submit",
    back: "back",
    cancel: "Cancel",
    select: "Select",
    serialNo: "S.No",
    title: "Title",
    description: "Description",
    price: "Price",
    status: "Status",
    actions: "Actions",
    name: "Name",
    normalCred: "Normal Credits",
    highlightedCred: "Highlighted Credits",
  },
  auth: {
    emailId: "Email Id",
    password: "Password",
    remember: "Remember me",
    forgotPassword: "Forgot Password",
    oldPass: "Old Password",
    confmPas: "Confirm Password",
    otpVerification: "OTP Verification",
    verify: "Verify",
    resendOtp: "Resend Otp",
    login: "Sign In",
    resendPass: "Reset Password",
    editProfile: "Edit Profile",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone Number",
    changePassword: "Change Password",
    resetPasswordTitle: "Reset Password",
    oldPasswordRequired: "Old password is required.",
    newPasswordRequired: "New password is required.",
    confirmPasswordRequired: "Confirm password is required.",
    passwordsMustMatch: "Passwords must match.",
    newPasswordSameAsOld: "New password cannot be same as old password.",
    passwordChangedSuccess: "Password changed successfully",
    passwordResetSuccess: "Password reset successfully",
  },
  main: {
    image: "Image",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    catName: "Category Name",
    selectCat: "Select Category",
    address: "Address",
    addSubAdmin: "Add Sub-Admin",
    addEdit: "Add/Edit",
    accountStatus: "Account Status",
    viewUser: "View Customer",
    editCustomer: "Edit Customer",
    question: "Question",
    answer: "Answer",
    contactSupport: "Contact Support",
    privacyPolicy: "Privacy Policy",
    aboutUs: "About Us",
    terms: "Terms And Conditions",
    changeLang: "Change language",
    notification: "Notifications",
    seeAll: "See All",
    myProfile: "My Profile",
    logout: "Logout",
    showing: "Showing",
    items: "items",
    active: "Active",

    Inactive: "Inactive",
    subscription: "Subscription",
    message: "Message",
    receiver: "Receiver",
    broadcast: "Broadcast",
    atLeast1Feature: "At least one Feature must be selected",
    loginToRe: "Log in to Real Estate Admin",
    date: "Date",
    credits: "Credits",
    addCredits: "Add Credits",
    export: "Export CSV",
    subCat: "Sub-Category",
    addSubCat: "Add Sub-Category",
    governorate: "Governorate",
    propertyName: "Property Name",
    confirmDelete: " Are you sure you want to delete this ",
    Yes: "Yes",
    No: "No",
    Back: "Back",
    SNo: "S.No",
    Delete: "Delete",
    Title: "Title",
    Action: "Action",
    Label: "Label",
    Status: "Status",
    Description: "Description",
    Price: "Price",
    AcountStatus: "Acount Status",
    acceptRequestsLeft: "Pending Requests",
    acceptRequests: "Total Requests",
    Name: "Name",
    Email: "Email",
    PhoneNo: "Phone No",
    TotalCredits: "Total credits",
    Totalcreditsused: "Total credits used",
    TotalCreditsLeft: "Total credits left",
    TotalCredits2: "Total credits (Subscription)",
    Totalcreditsused2: "Total credits used (Subscription)",
    TotalCreditsLeft2: "Total credits left (Subscription)",
    TotalCreditsPending: "Total credits pending",
    PlanPrice: "Plan Price",
    PurchaseDate: "Purchase Date",
    PlanName: "Plan Name",
    NormalListingCredits: "Normal Listing Credits",
    HighlightedListingCredits: "Highlighted Listing Credits",
    PlanDetails: "Plan Details",
    CreditDetails: "Credit Details",
    Governorate: "Governorate",
    NoAreaFound: "No Area Found",
    AddGovernorate: "Add Governorate",
    ManageAreas: "Manage Areas",
    ManageSubscriptionPlan: "Manage Subscription Plan",
    PurchasedSubscriptions: "Purchased Subscriptions",
    AddPlan: " Add Plan",
    Image: "Image",
    CategoryName: "Category Name",
    SubCategory: "Sub-Category",
    NoCategoryFound: "No Category Found",
    ManageCategories: "Manage Categories",
    AddSubcategory: "Add Sub-category",
    ManageSubAdmin: "Manage Sub-Admin",
    Phone: "Phone",
    Nosubadminsfound: " No sub-admins found.",
    Add: "Add",
    PropertiesforSale: "Properties for Sale",
    PropertiesforRent: "Properties for Rent",
    PropertiesforExchange: "Properties for Exchange",
    MostViewedProperties: "Most Viewed Properties",
    MostSearchedProperties: "Most Searched Properties",
    Pleaseselectcategory: "Please select category",
    Type: "Type",
    Location: "Location",
    CustomerName: "Customer Name",
    AgentCustomerName: "Customer / Agent Name",
    AgentName: "	Agent Name",
    PropertyCategory: "Property Category",
    PropertyName: "Property Name",
    NoPropertiesFound: " No Properties Found",
    Mostsearchedbyarea: " Most searched by area",
    UserPreferences: "User Preferences",
    All: "All",
    ManageProperties: "Manage Properties",
    VideoTitle: "Video Title",
    AddTutorial: "  Add Tutorial",
    NoTutorialFound: " No Tutorial Found",
    ManageTutorials: "Manage Tutorials",
    ManagePayments: "Manage Payments",
    PaymentMode: "Payment Mode",
    PaymentType: "Payment Type",
    Amount: "Amount",
    TotalEarnings: "Total Earnings",
    ReportsandAnalytics: "Reports and Analytics",
    EditProfile: "Edit Profile",
    Save: "Save",
    Sort: "Sort by alphabets",
    Sort2: "Sort by no. of properties",
    Option1: "A to Z",
    Option2: "Z to A",
    Option3: "Low to high",
    Option4: "High to low",
    PhoneNumber: "Phone Number",
    FirstName: "First Name",
    LastName: "Last Name",
    FullName: "Full Name",
    EditAgentProfile: "Edit Agent Profile",
    EditTutorial: "Edit Tutorial",
    UploadVideos: " Upload Videos",
    DescriptionArabic: "Description (Arabic)",
    TitleArabic: "Title (Arabic)",
    ContactSupport: "Contact Support",
    PrivacyPolicy: "Privacy Policy",
    TermsConditions: "Terms & Conditions",
    AgentTermsConditions: "Agent Terms & Conditions",
    CreditPrice: "Credit Price",
    RealEstateLinks: "Real Estate Links",
    AppSettings: "App Settings",
    AppUpdate: "App Update",
    ForceUpdate: "Force Update",
    Maintenance: "Maintenance",
    ManageSettings: "Manage Settings",
    WhatsappPhoneNumber: " Whatsapp Phone Number",
    PrivacyPolicyEnglish: "Privacy Policy ( English )",
    Pleaseenterprivacypolicy: "Please enter privacy policy",
    PrivacyPolicyArabic: "Privacy Policy ( Arabic )",
    PleaseenterTermsandConditions: "Please enter Terms and Conditions",
    TermsConditionsArabic: "Terms & Conditions ( Arabic )",
    TermsConditionsEnglish: "Terms & Conditions ( English )",
    NormalCredits: " Normal Credits",
    HighlightedCredits: "  Highlighted Credits",
    agentRequestPrice: "Property Request Price Per Agent",
    TotalUsers: " Total Users",
    ManageNotifications: "Manage Notifications",
    AddNotification: " Add Notification",
    NoNotificationFound: "No Notification Found",
    receivedNotifications: "Received Notifications",
    Filter: "Filter",
    kd: "KD",
    EditUserProfile: "Edit User Profile",
    ManageFaqs: "Manage Faqs",
    QuestionEnglish: "    Question ( English )",
    QuestionArabic: "    Question ( Arabic )",
    AnswerEnglish: "Answer (English)",
    AnswerArabic: "Answer (Arabic)",
    Remove: "Remove",
    Arabic: "Arabic",
    English: "English",
    PaymentDetails: "Payment Details",
    SubscriptionPlan: "Subscription Plan",
    NotificationTitle: "   Notification Title",
    SelectReceiver: "  Select Receiver",
    Edit: "Edit",
    Module: "Module",
    View: "View",
    EditSubscriptionPlan: "Edit Subscription Plan",
    PlanValidity: "Plan Validity",
    PlanFeatures: "   Plan Features",
    Feature: "Feature",
    AddSubscriptionPlan: "Add Subscription Plan",
    EditSubAdmin: "Edit Sub-Admin",
    AddSubAdmin: "Add Sub-Admin",
    Showrequesttoagents: "Show request to agents",
    ManageRequest: "Manage Request",
    Month: "Month",
    Months: "Months",
    Day: "Day",
    Days: "Days",
    Hour: "Hour",
    Hours: "Hours",
    Minute: "Minute",
    Minutes: "Minutes",
    ValidityUnit: "Validity Unit",
    PleaseselectValidity: "Please select Validity",
    Category: "Category",
    NoSubcategoryFound: " No Sub-category Found",
    ManageSubCategory: "Manage Sub-Category",
    Validity: "Validity",
    Area: "Area",
    Please: "Please",
    Total: "Total",
    Map: "Map",
    Link: "Link",
    Agent: "Agent",
    User: "User",
    For: "For",
    Normal: "Normal",
    Hightlighted: "Hightlighted",
    Upload: "Upload",
    Property: "Property",
    Yourbrowserdoesnotsupportthevideotag:
      " Your browser does not support the video tag.",
    Totalareainmetersquare: "Total area in meter square",
    dateOfPurchase: "Date of Purchase",
    ExpiryDate: "Expiry Date",
    SubscriptionType: "Subscription Type",
    noactivesubscription: "no active subscription",
    subCatNameEn: "Sub-category Name ( English )",
    subCatNameAr: "Sub-category Name ( Arabic )",
    subCatName: "Sub-category Name",
    categoryNameEn: "Category Name (english)",
    categoryNameAr: "Category Name (arabic)",
    viewSubCategories: "View Sub-Categories",
    manageSubAreas: "Manage Sub-Areas",
  },
  dashboard: {
    dashboard: "Dashboard",
    totalUsers: "Total Users",
    totalAgent: "Total Agent",
    totalProperty: "Total Properties",
    forSale: "Properties for Sale",
    forRent: "Properties for Rent",
    forExchange: "Properties for Exchange",
    earnings: "Total Earnings",
    userEarning: "Earnings from Users",
    agentEarning: "Earnings from Agents",
    subscriptionEarning: "Earnings from Subscriptions",
    avgEarnings: "Avg. Monthly Earnings",
    byArea: "Properties Searched by Area",
    Earning: "Earnings",
    User: "User",
    Property: "Properties",
    ExportCsv: "Export CSV",
    Hourly: "Hourly",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly",
    Select: "Select",
    refresh: "Refresh",
  },
  sideBar: {
    dashboard: "Dashboard",
    subAdmin: "Manage Sub-Admins",
    user: "Manage Users",
    agent: "Manage Agents",
    plans: "Manage Subscription Plans",
    category: "Manage Categories",
    property: "Manage Properties",
    areas: "Manage Areas",
    tutorial: "Promotional Tutorials",
    payments: "Manage Payments",
    noti: "Manage Notifications",
    reports: "Reports and Analytics",
    faqs: "Manage FAQs",
    setting: "Settings",
    notifications: "Manage Notifications",
    analytics: "Analytics",
    promotionalCode: "Manage Promotional Code",
    refundRequests: "Refund Requests",
  },
  error: {
    required: "This field is required",
    validation1: "Please select a valid video",
    maxValidation: "Maximum 80 character are allowed",
    maxValidation200: "Maximum 200 characters are allowed",
    minValidation: "Minimum 3 characters are required",
    noData: "No results found",
    titlereq: "Title is required",
    descReq: "Description is required",
    noFaq: "No faq's listing found",
    emailReq: "Email is required!",
    validEmail: "Enter a valid email address!",
    firstReq: "First name is required",
    lastReq: "Last name is required",
    phoneReq: "Phone number is required",
    minPhone: "Phone number must be at least 6 digits",
    maxPhone: "Phone number must be at least 16 digits",
    subAdminCreated: "Sub-admin created successfully",
    subAdminUpdate: "Sub-admin updated successfully",
    userUpdate: "User updated successfully",
    statusUpdate: "Status updated successfully",
    subAdminDel: "Sub-admin deleted successfully",
    userDel: "User deleted successfully",
    max100: "Maximum 100 character are allowed",
    max250: "Maximum 250 character are allowed",
    max500: "Maximum 500 character are allowed",
    catAdd: "Category added successfully",
    catUpdate: "Category updated successfully",
    settingUpdate: "Settings updated successfully",
    faqAdd: "FAQ added successfully",
    faqUpd: "FAQ updated successfully",
    faqDel: "FAQ deleted successfully",
    cmsUpdate: "CMS updated successfully",
    messageReq: "Message is required",
    notiAdd: "Notification added successfully",
    notiDel: "Notification deleted successfully",
    notiSent: "Notification sent successfully",
    maxValidation20: "Maximum 20 character are allowed",
    maxValidation450: "Maximum 450 character are allowed",
    logutReq: "Are you sure, you want to logout?",
    pleaseTryAgain: "Please try again",
    catDel: "Category deleted successfully",
    subCatDel: "Sub-category deleted successfully",
    subCatAdd: "Sub-category added successfully",
    subCatUpdate: "Sub-category updated successfully",
    maxValidation30: "Maximum 30 character are allowed",
    maxValidation15: "Maximum 15 characters are allowed",
    minValidation2: "Minimum 2 characters are required",
    imagesOnly: "This field only accepts images.",
    creditsAdded: "Credits added successfully",
    tutorialUpdate: "Tutorial updated successfully",
    tutorialAdd: "Tutorial added successfully",
    tutorialDel: "Tutorial deleted successfully",
    planUpdate: "Plan updated successfully",
    planAdd: "Plan added successfully",
    subDel: "Subscription deleted successfully",
    propertyDel: "Property deleted successfully",
    propertyUpdate: "Property updated successfully",
    propertyAdd: "Property added successfully",
    exportFailed: "Export failed. Please try again.",
    invalidVideo: "Please select a valid video",
    invalidVideoFormat: "Invalid file format: only video files are allowed",
    uploadFailed: "Upload failed. Please try again.",
    invalidFileType: "Invalid file type. Please upload only images or videos.",
    maxMediaSeven: "Cannot upload more than 7 images or videos",
    fillOneCreditField: "Please fill in at least one credit field",
    noSpacesOnly: "This field cannot contain only spaces",
    permissionRequired: "At least one permission must be selected",
    profileUpdated: "Profile updated successfully",
  },
  discount: {
    promoCodeDeleted: "Promo Code deleted successfully",
    noPromoCodeFound: "No Promotional Code Found",
    promoCodeUpdated: "Promotional Code Updated successfully",
    promoCodeAdded: "Promotional Code Added Successfully",
    percentage: "Percentage",
    flat: "Flat",
    highlighted: "Highlighted",
    normal: "Normal",
    both: "Both",
  },
  payment: {
    dateOfPurchase: "Date of Purchase",
    credits: "Credits",
    subscription: "Subscription",
    agentRequest: "Agent Request",
    transactionId: "Transaction ID",
    providerChargeId: "Provider Charge ID",
    paymentStatus: "Payment Status",
    providerStatus: "Provider Status",
    pending: "Pending",
    completed: "Completed",
    cancelled: "Cancelled",
    refunded: "Refunded",
    failureReason: "Failure Reason",
    noPaymentsFound: "No Payments Found",
    card: "Card",
  },
  roundUp: {
    title: "Manage Round Up Configuration",
    minimumLimit: "Minimum Limit",
    maximumLimit: "Maximum Limit",
    numberOfBreakpoints: "Number of Breakpoints",
    numberOfBreakPointsPlaceholder: "Number of Break Points",
    multipliers: "Multipliers",
    addMultiplier: "Add Multiplier",
    multiplier: "Multiplier",
  },
  plans: {
    planName: "Plan Name",
    planValid: "Plan Validity",
    planPrice: "Plan Price",
    feature: "Features",
  },
  user: {
    Actions: "Actions",
    Credits: "Credits",
    AccountStatus: "Account Status",
    Email: "Email",
    PhoneNo: "Phone No",
    Name: "Name",
    SNo: "S.No",
    ManageUsers: "Manage Users",
    ExportCsv: "Export CSV",
    SearchHere: "Search Here",
    Showing: "Showing",
    items: "items",
    AddCredits: "Add Credits",
    HighlightedCredits: " Highlighted Credits",
    NormalCredits: "Normal Credits",
    ViewUserProfile: "View User Profile",
    noUsersFound: "No Users Found",
    view: "View",
    edit: "Edit",
    delete: "Delete",
  },
  agents: {
    Actions: "Actions",
    Credits: "Credits",
    AccountStatus: "Account Status",
    Email: "Email",
    PhoneNo: "Phone No",
    Name: "Name",
    SNo: "S.No",
    ManageAgents: "Manage Agents",
    ExportCsv: "Export CSV",
    SearchHere: "Search Here",
    Showing: "Showing",
    items: "items",
    AddCredits: "Add Credits",
    HighlightedCredits: " Highlighted Credits",
    NormalCredits: "Normal Credits",
    NoAgentFound: "No Agent Found",
    Cancel: "Cancel",
    Add: "Add",
    Agent: "Agent",
    ViewAgentProfile: "View Agent Profile",
    Subscribed: "Subscribed",
    allAgentsNewest: "All agents (newest)",
    pendingLicense: "Pending license",
    acceptedLicense: "Accepted license",
    rejectedLicense: "Rejected license",
    documentStatusUpdated: "Document status updated",
    agentDeleted: "Agent deleted successfully",
    pending: "Pending",
    documentStatus: "Document Status",
    accepted: "Accepted",
    accept: "Accept",
    rejected: "Rejected",
    reject: "Reject",
    subscribedYes: "Yes",
    subscribedNo: "No",
    profile: "Profile",
    licenseDocuments: "License Documents",
    normalCreditsBought: "Normal Credits bought",
    highlightedCreditsBought: "Highlighted Credits bought",
    planSubscriptionDetails: "Plan Subscription Details",
    request: "Request",
    totalRequestsPlan: "Total Requests (Plan)",
    requestsUsed: "Requests Used",
    remainingRequests: "Remaining Requests",
    normalCreditsPlan: "Normal Credits (Plan)",
    normalCreditsUsed: "Normal credits used",
    normalCreditsAvailable: "Normal credits available",
    highlightCreditsPlan: "Highlight Credits (Plan)",
    highlightsCreditsUsed: "Highlights credits used",
    highlightsCreditsAvailable: "Highlights credits available",
    noLicenseDocument: "No license document uploaded",
    viewLicense: "View License",
    downloadLicense: "Download License",
    requestToAgentCredits: "Request to Agent credits",
    acceptRequestCredits: "Accept request credits",
  },
  cms: {
    linkAdded: "Link added successfully",
    linkDeleted: "Link deleted successfully",
    addLinks: "Add Links",
    linkTitle: "Title",
    linkTitleAr: "Title (Arabic)",
    linkUrl: "Link",
    linkIcon: "Icon",
    linkIconRequired: "Please upload an icon",
    contactSupportUpdated: "Contact support updated successfully",
    privacyPolicyUpdated: "Privacy policy updated successfully",
    termsUpdated: "Terms & conditions updated successfully",
    agentTermsUpdated: "Agent terms & conditions updated successfully",
    creditPriceUpdated: "Credit price updated successfully",
    appSettingsUpdated: "App settings updated successfully",
    appUpdate: "App Update",
    forceUpdate: "Force Update",
    maintenance: "Maintenance",
    appSettingsDescription:
      "Manage app update, force update, and maintenance per platform. Set Version higher than the installed app version to trigger update popups.",
    appSettingsHint:
      "Scenarios: (1) App Update ON + higher Version = optional update popup. (2) Force Update ON + higher Version = mandatory update popup. (3) Maintenance ON = maintenance popup.",
    platformType: "Type",
    version: "Version",
    forceUpdates: "Force Updates",
    maintenanceMode: "Maintenance Mode",
    lastUpdated: "Last Updated",
    featureSettings: "Tap & Pay Settings",
    quickCheckoutFeature: "Enable Tap & Pay",
    featureSettingsDescription: "Enable or disable Tap & Pay payment option for mobile application users.",
    featureSettingsUpdated: "Tap & Pay settings updated successfully",
    userLabel: "user",
    versionRequiredForUpdate: "Set a Version higher than the live app to enable App Update / Force Update.",
    publicLinksTitle: "Public Links",
    publicLinksDescription:
      "Use these URLs in App Store Connect and Google Play Console for privacy policy, terms, and support.",
    publicLinksPage: "Page",
    publicLinksUrl: "Public URL",
    publicLinksCopy: "Copy URL",
    publicLinksOpen: "Open in new tab",
    publicLinksCopied: "URL copied",
  },
  areas: {
    governorateDeleted: "Governorate deleted successfully",
    governorateUpdated: "Governorate updated successfully",
    governorateAdded: "Governorate added successfully",
    byAlphabets: "By alphabets",
    byAreas: "By areas",
    keyLabel: "Key",
  },
  labels: {
    labelDeleted: "Label deleted successfully",
    labelSaved: "Labels saved successfully",
    saleRentExchange: "Sell / Rent / Exchange labels",
    englishLabel: "English label",
    arabicLabel: "Arabic label",
    manageLabels: "Manage Labels",
    addLabels: "Add Labels",
    labelAdded: "Label added successfully",
  },
  refunds: {
    statusUpdated: "Refund status updated successfully",
    pending: "Pending",
    refunded: "Refunded",
    manageRefunds: "Refund Requests",
    refundedAmount: "Refunded Amount",
    dateOfRequest: "Date of Refund Request",
    userName: "User Name",
    userEmail: "User Email",
    userPhone: "User Phone",
    refundStatus: "Refund Status",
    filter: "Filter",
    refundAction: "Refund",
    cancelled: "Cancelled",
    statusUpdateFailed: "Failed to update refund status",
    updateError: "Error updating refund status",
    noRefundsFound: "No Refund Requests Found",
  },
  tutorials: {
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    descEn: "Description (English)",
    descAr: "Description (Arabic)",
  },
  subscription: {
    planNameEn: "Plan Name ( English )",
    planNameAr: "Plan Name ( Arabic )",
    descEn: "Description ( English )",
    descAr: "Description ( Arabic )",
    planPrice: "Plan Price",
    highlightedCredits: "Highlighted Credits",
    acceptRequest: "Accept Request",
    active: "Active",
    expired: "Expired",
    cancelled: "Cancelled",
    noPurchases: "No purchased subscriptions found",
  },
  properties: {
    propertyDetails: "Property Details",
    aboutProperty: "About the property",
    imagesAndVideos: "Images & Videos",
    mapLink: "Map link",
    mtSq: "mt sq",
    clearFilters: "Clear filters",
    selectArea: "Select Area",
    listingNormal: "Normal",
    listingHighlighted: "Highlighted",
    listingAgent: "Agent",
    requestToAgent: "Request to Agent",
    byAdmin: "By Admin",
    customTitle: "Custom Title",
    views: "Views",
    listingType: "Listing Type",
    listingStatus: "Listing Status",
    blockStatus: "Block Status",
    propertyType: "Property Type",
    createdBy: "Created By",
    sell: "Sell",
    rent: "Rent",
    exchange: "Exchange",
    pending: "Pending",
    published: "Published",
    expired: "Expired",
    draft: "Draft",
    saveForLater: "Save for later",
    rejected: "Rejected",
    sold: "Sold",
    rtaTimeout: "RTA timeout",
    refundInProgress: "Refund in progress",
    negotiablePrice: "Negotiable Price",
    dontDisturb: "Don't Disturb",
    publishedFlag: "Published",
    searchCount: "Search Count",
    email: "Email",
    phone: "Phone",
    createdAt: "Created At",
    publishedAt: "Published At",
    highlightedAt: "Highlighted At",
    expiredAt: "Expired At",
    acceptedByAgentAt: "Accepted By Agent At",
    saveForLaterAt: "Save For Later At",
    expireStatus: "Expire Status",
    isResubmit: "Resubmitted",
    isRefundRequested: "Refund Requested",
  },
  manageDiscount: {
    managePromotionalCode: "Manage Promotional Code",
    addPromotionalCode: "Add Promotional Code",
    discountCode: "Discount Code",
    discountName: "Discount Name",
    discountType: "Discount Type",
    couponType: "Coupon type",
    discountValue: "Discount Value",
    minAmountToApply: "Min Amount To Apply",
    startDate: "Start Date",
    endDate: "End Date",
    status: "Status",
    percentage: "Percentage",
    flat: "Flat",
    highlighted: "Highlighted",
    normal: "Normal",
    both: "Both",
    noPromotionalCodeFound: "No Promotional Code Found",
    promoCodeDeleted: "Promo Code deleted successfully",
    statusUpdated: "Status updated successfully",
    pleaseTryAgain: "Please try again",
    editPromotionalCode: "Edit Promotional Code",
    selectDiscountType: "Select Discount Type",
    userType: "User Type",
    applyCodeFor: "Apply Code For",
    selectedAgents: "Selected Agents",
    selectedUsers: "Selected Users",
    selectedUsersAgents: "Selected Users & Agents",
    allAgents: "All Agents",
    allUsers: "All Users",
    allUsersAgents: "All Users & Agents",
    selectUsers: "Select Users",
    searchUsers: "Search users",
    pleaseSelectDiscountType: "Please Select Discount Type",
    pleaseSelectType: "Please Select Type",
    promoCodeUpdated: "Promotional Code Updated successfully",
    promoCodeAdded: "Promotional Code Added Successfully",
    max20: "Maximum 20 character are allowed",
    min2: "Minimum 2 characters are required",
    percent: "Percent",
  }
};
